import { Controller } from 'stimulus'

export default class extends Controller {
    static values = {
        url: String
    }

    print() {
        window.open(this.urlValue).print()
    }

    printInline() {
        const iframe = document.getElementById('print-frame') || document.createElement('iframe')

        iframe.id = 'print-frame'
        iframe.style.display = 'none'

        document.body.appendChild(iframe)

        iframe.onload = function() {
            setTimeout(function() {
                iframe.contentWindow.print()
            }, 500)
        }

        iframe.src = this.urlValue
    }
}
